import ReactDOM from "react-dom";
import React, { useEffect, useRef, useState } from 'react';
import langData from '../locales/langData.json';
import vid from '../assets/images/video-thum.webp';
import ProductFeatureLive from '../components/ProductFeatureLive';
import centerBox from '../assets/images/web-plat.webp';
import centerBoxMob from '../assets/images/mob-center-icon.svg';
import arrow from '../assets/images/right-arrow.webp';
import FaqLive from '../components/FaqLive';
import playicon from '../assets/images/play-icon.webp'
import DemoForm from '../components/Forms/DemoForm';
import SEO from '../components/SEO';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ClientLogoMarquee from '../components/ClientLogoMarquee';


// ✅ Reusable CountUp component
const CountUp = ({ end, duration, trigger }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!trigger) return; // wait until visible
        let start = 0;
        const incrementTime = 10;
        const totalSteps = (duration * 1000) / incrementTime;
        const increment = end / totalSteps;

        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                clearInterval(timer);
                setCount(end);
            } else {
                setCount(Math.floor(start));
            }
        }, incrementTime);

        return () => clearInterval(timer);
    }, [end, duration, trigger]);

    return <>{count}</>;
};



const Live = ({ language }) => {
    const live = langData[language].live;
    const product = langData[language].products;
    const clientlogos = langData[language].clientlogo;
    const imgRef = useRef(null);
    const counterRef = useRef(null);
   
       const [showModal, setShowModal] = useState(false);
       const [visible, setVisible] = useState(false);
   
      
   
       // ✅ Scroll fade-in animation
       useEffect(() => {
           const handleScroll = () => {
               const element = imgRef.current;
               if (!element) return;
   
               const rect = element.getBoundingClientRect();
               const windowHeight = window.innerHeight;
               const progress = 1 - rect.top / windowHeight;
               const clamped = Math.min(Math.max(progress, 0), 1);
   
               element.style.opacity = 1;
               element.style.transform = `translateY(${180 - clamped * 160}px)`;
           };
   
           window.addEventListener("scroll", handleScroll);
           handleScroll();
           return () => window.removeEventListener("scroll", handleScroll);
       }, []);
   
       // ✅ IntersectionObserver for CountUp
       useEffect(() => {
           const observer = new IntersectionObserver(
               ([entry]) => {
                   if (entry.isIntersecting) setVisible(true);
               },
               { threshold: 0.3 }
           );
   
           if (counterRef.current) observer.observe(counterRef.current);
           return () => observer.disconnect();
       }, []);

    return (
        <>
            <SEO
                title="CaptainX Live | Live Scoring & Streaming Solution"
                titleAr="كابتن اكس لايف | حلول البث المباشر والنتائج المباشرة"
                description="Real-time sports scoring, streaming & tournament management. Engage fans with live updates and AI-powered insights."
                descriptionAr="تسجيل النتائج الرياضية، والبث المباشر، وإدارة البطولات. تفاعل مع الجماهير من خلال التحديثات المباشرة والرؤى المعززة بالذكاء الاصطناعي."
                path="/products/live"
                language={language}
            />

             {showModal &&
                ReactDOM.createPortal(
                   <DemoForm
  language={language}
  onClose={() => setShowModal(false)}
/>,

                    document.body
                )
            }

            <div className="indual-product-section">
                <div className="m-indu-first">
                    <div className="container">

                        <center>
                            <div className="indual-hero-m">
                                <div className="cen-sec-con">
                                    <h6 className='sec-top-titl block-view mt-3'>{live.secTopTitle}</h6>
                                    <h2
                                        className='sec-title block-view'
                                        dangerouslySetInnerHTML={{ __html: live.title }}
                                    />
                                    <p className='block-view hero-text-p'>{live.desc}</p>
                                    <div className="mob-btn">

                                        <button
                                            className={`explore-btn cta-btn my-4 py-2 gap-3 block-view ${language === "ar" ? "ar-padding" : "en-padding"
                                                } `} 
                                                 onClick={() => setShowModal(true)}
                                        >{live.btn}

                                            <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                                        </button>
                                    </div>


                                </div>
                            </div>
                        </center>

                        <div className="ind-img-over scroll-fade-scroll" ref={imgRef}>
                            <LazyLoadImage src={vid} alt="video-thumb" className="scroll-fade-scroll" />
                            <div className="play-icon">
                                <LazyLoadImage src={playicon} alt="play-icon" />
                            </div>
                        </div>
                    </div>
                    <div className="scond-product-part">
                        <div className="marq">
                            <center>
                                <h5 className="second-cen-text pt-3">{product.morequee}</h5>
                                <ClientLogoMarquee logos={clientlogos} language={language} />
                            </center>
                        </div>
                    </div>
                </div>
            </div>


            {/* ✅ Number Counter Section */}
            <section className='future-sec'>
                <div className="container">
                    <div className="row justify-content-center align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-md-6 " ref={counterRef}>
                            <h2
                                className="sec-title futer-title block-view"
                                dangerouslySetInnerHTML={{ __html: live.futureTitle }}
                            />
                            <p className="sec-p futer-p block-view">{live.futureDesc}</p>
                        </div>

                        <div className="col-md-2"></div>

                        {/* RIGHT NUMBERS */}
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="num-card-box">
                                        <div className="number-count">
                                            <CountUp end={live.num1} duration={2} trigger={visible} />
                                            <span>{live.numspan}</span>
                                        </div>
                                        <div className="number-desc">{live.num1Desc}</div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="num-card-box num-box-2">
                                        <div className="number-count-two">
                                            <CountUp end={live.num2} duration={2} trigger={visible} />
                                            <span>{live.numspan}</span>
                                        </div>
                                        <div className="number-desc">{live.num2Desc}</div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="num-card-box num-box-2">
                                        <div className="number-count-two">
                                            <CountUp end={live.num3} duration={2} trigger={visible} />
                                            <span>{live.numsx}</span>
                                        </div>
                                        <div className="number-desc">{live.num3Desc}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <ProductFeatureLive language={language} />


            {/* PLATFORM SECTION */}
            <section className='platform'>
                <div className="container">
                    <center>
                        <h2 className='sec-title'>{live.platformTitle}</h2>
                        {/* <p className='d-none d-md-block sec-desc'>{live.platformDesc}</p> */}
                    </center>

                    <div className="row justify-content-center align-items-center mt-5">
                        <div className="col-md-4 d-block d-md-none mb-4">
                            <center>
                                <LazyLoadImage src={centerBoxMob} alt="center-box " className='img-fluid d-block d-md-none' />
                                <LazyLoadImage src={centerBox} alt="center-box " className='img-fluid d-none d-md-block' />
                            </center>
                        </div>

                        <div className="col-md-4">
                            <div className="card-wrap">
                                <div className="icon-box">
                                    <div className="icon">
                                        <LazyLoadImage src={live.platformlist1icon} alt={live.platformlist1icon} />
                                    </div>
                                    <div className="icon-box-con">
                                        <h6>{live.platformlist1Title}</h6>
                                        <p>{live.platformlist1Desc}</p>
                                    </div>
                                </div>

                                <div className="icon-box">
                                    <div className="icon">
                                        <LazyLoadImage src={live.platformlist2icon} alt={live.platformlist2icon} />
                                    </div>
                                    <div className="icon-box-con">
                                        <h6>{live.platformlist2Title}</h6>
                                        <p>{live.platformlist2Desc}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 d-none d-md-block">
                            <center>
                                <LazyLoadImage src={centerBox} alt="center-box" className='img-cen' />
                            </center>
                        </div>

                        <div className="col-md-4">
                            <div className="card-wrap">
                                <div className="icon-box">
                                    <div className="icon">
                                        <LazyLoadImage src={live.platformlist3icon} alt={live.platformlist3icon} />
                                    </div>
                                    <div className="icon-box-con">
                                        <h6>{live.platformlist3Title}</h6>
                                        <p>{live.platformlist3Desc}</p>
                                    </div>
                                </div>

                                <div className="icon-box">
                                    <div className="icon">
                                        <LazyLoadImage src={live.platformlist4icon} alt={live.platformlist4icon} />
                                    </div>
                                    <div className="icon-box-con">
                                        <h6>{live.platformlist4Title}</h6>
                                        <p>{live.platformlist4Desc}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <FaqLive language={language} />


            {/* CTA */}
            <section className='cta py-5 my-4'>
                <div className="container">
                    <center>
                        <h2
                            className='sec-title block-view'
                            dangerouslySetInnerHTML={{ __html: live.ctaTitle }}
                        ></h2>
                        <p
                            className="sec-p block-view"
                            dangerouslySetInnerHTML={{ __html: live.ctadesc }}
                        ></p>
                        <button
                            className={`explore-btn cta-btn my-4 py-2 gap-3 block-view ${language === "ar" ? "ar-padding" : "en-padding"
                                } `} 
                                 onClick={() => setShowModal(true)}
                        >{live.ctabutton}

                            <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                        </button>
                    </center>
                </div>
               
            </section>
        </>
    );
};

export default Live;
